import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { fetchIntakesApi } from '../../api/intakes-api';
import { setQuickLinks } from 'reducers/quick-links-slice';

const initialState = {
  activeColumns: [],
  intakes: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchIntakesListing = createAsyncThunk(
  'intakes/listing',
  async (updatedParamsObject = {}, { dispatch }) => {
    try {
      const paramsObj = {
        ...updatedParamsObject,
      };
      const res = await fetchIntakesApi(paramsObj, '');
      if (res?.status) {
        dispatch(setQuickLinks(res?.user_filters));
      }
      return res;
    } catch (error) {
      toast.error(getErrorString(error));
    }
  },
);

const IntakesSlice = createSlice({
  name: 'intakes',
  initialState,
  reducers: {
    setIntakesLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setIntakesActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchIntakesListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchIntakesListing.fulfilled, (state, action) => {
        if (state.loading) {
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.intakes = action?.payload?.data || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchIntakesListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      });
  },
});

export const { setIntakesLoading, setIntakesActiveColumn } = IntakesSlice.actions;
export default IntakesSlice.reducer;
